var map = {
	"./adventure-entrance.gif": 30287,
	"./amulet.gif": 41193,
	"./backpack.gif": 63866,
	"./battle-preview.gif": 16201,
	"./battle-public.gif": 99365,
	"./battle.gif": 28203,
	"./chimpo-adventure.gif": 28818,
	"./chimpo.gif": 25423,
	"./chimpvolution/background.gif": 69298,
	"./chimpvolution/gem12.gif": 48932,
	"./chimpvolution/gem13.gif": 23128,
	"./chimpvolution/gem14.gif": 50541,
	"./chubby-octopus.gif": 75086,
	"./chubby.gif": 51649,
	"./corridor-side.gif": 62212,
	"./corridor.gif": 38790,
	"./dojo-christmas.gif": 23522,
	"./dojo-deck.gif": 35323,
	"./dojo-halloween.gif": 16017,
	"./dojo-renovated.gif": 7364,
	"./dojo-snow-no-mc.gif": 78642,
	"./dojo-snow.gif": 45458,
	"./dojo-wo-chubby-mc.gif": 74332,
	"./dojo-wo-chubby.gif": 16298,
	"./dojo-wo-mc.gif": 92506,
	"./dojo.gif": 65087,
	"./egg-chimpo.gif": 44343,
	"./egg-fight.gif": 42847,
	"./egg-ramen.gif": 52671,
	"./fight_scene.gif": 90927,
	"./game-select.gif": 86282,
	"./guard.gif": 90402,
	"./inventory.gif": 43337,
	"./loading-page.gif": 84658,
	"./loading-text.gif": 47669,
	"./loading.gif": 76053,
	"./museum/ep1.gif": 12884,
	"./museum/ep2.gif": 77552,
	"./museum/ep4.gif": 43092,
	"./museum/ep5.gif": 35380,
	"./museum/ep6.gif": 15650,
	"./museum/text-box-2.gif": 82013,
	"./museum/text-box-3.gif": 79976,
	"./museum/text-box-4.gif": 80740,
	"./museum/text-box-5.gif": 15369,
	"./museum/text-box-6.gif": 87345,
	"./museum/text-box.gif": 80959,
	"./notice-board.gif": 91922,
	"./professor.gif": 95435,
	"./replay-bg.gif": 17746,
	"./stake.gif": 66326,
	"./updated-dojo.gif": 26900,
	"./vs.gif": 3340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97628;